import { logStartUsage } from 'owa-analytics-start';
import type RetryStrategy from 'owa-shared-start/lib/interfaces/RetryStrategy';
import { type ErrorRetryStrategy } from 'owa-shared-start/lib/interfaces/ErrorRetryStrategy';
import { addQueryStringParameterForRedirect } from 'owa-shared-start/lib/doErrorRetryRedirect';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isAttendeePath } from './isAttendeePath';

export default function overrideRetryStrategy(
    bootResult: string | undefined
): RetryStrategy | null {
    if (bootResult == 'errorfe' || bootResult == 'configuration') {
        logStartUsage('BookWithMeOverrideRetryStrategy', { bootResult });
        const userConfig = getUserConfiguration();
        let isOnPrem = false;

        try {
            isOnPrem = userConfig?.SessionSettings?.IsSPOnPrem ?? true;
        } catch (e) {
            isOnPrem = true;
        }
        const isAttendeePage = isAttendeePath();

        if (isAttendeePage) {
            addQueryStringParameterForRedirect('anonRetry', '');
            if (isOnPrem) {
                logStartUsage('BookWithMeOnPremiseUser');
            } else {
                logStartUsage('BookWithMeNonOnPremiseUser');
            }
        } else if (bootResult == 'configuration' && !isAttendeePage) {
            // shortcut out if there is a configuration error not on an attendee page
            // in that case, we want the default behavior to kick in.
            return null;
        }
        return { strategy: '1' };
    }
    return null;
}
